import { render } from "./CarOrderDetails.vue?vue&type=template&id=497fe1bf"
import script from "./CarOrderDetails.vue?vue&type=script&lang=js"
export * from "./CarOrderDetails.vue?vue&type=script&lang=js"

import "./CarOrderDetails.vue?vue&type=style&index=0&id=497fe1bf&lang=scss"

import exportComponent from "D:\\wwwroot\\yunchi\\yc-vue-source\\yunman\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__